import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import {
	centralInvoiceRecipientQueries,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


export const useCompaniesCentralInvoiceRecipientsSelectOptions = (companyId: string): FormInputOption[] => {
	const { data: centralInvoiceRecipients } = useQuery(centralInvoiceRecipientQueries.byCompany(companyId));
	return useMemo(() => {
		if (centralInvoiceRecipients) {
			return centralInvoiceRecipients
				.sort(byObjectProperty("displayName"))
				.map((centralInvoiceRecipient) => {
					const nameWithClient = `${centralInvoiceRecipient.displayName} (${centralInvoiceRecipient.client.displayName})`;
					return createInputOptionData(nameWithClient, centralInvoiceRecipient.id);
				});
		}
		return [];
	}, [centralInvoiceRecipients]);
};

